import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { parse } from 'query-string';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

import { Container, palette, TabsPanel } from '@dev/ee-components';
import { AccessLevel } from '@dev/ee-api/ee-api-models';
import { push as Push } from 'redux-first-history';

import { DEFAULT_PER_PAGE_COUNT } from '@/services/constants';
import { ApplicationState } from '@/store';
import { GetContactFieldsStart } from '@/store/customFields/actions';
import { ContactsPaths } from '@/services/dictionaries/Paths';

import { hasAccessLevel } from '@/services/Secuirty';
import { AddNewField } from './AddCustomField';
import { CustomFieldsTable } from './CustomFieldTable';

const ScreenContainer = styled.div`
    input {
        padding: 0;
        border: 0; //prevent 2018 styles
    }
    & .MuiAlert-root {
        margin: 24px 0;
        color: ${palette.gray[7]};
    }
`;

const TopNavigation = (): JSX.Element => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    return (
        <TabsPanel
            breadcrumbs={t('segments')}
            title={t('customfields')}
            breadcrumbsOnClick={(): void => {
                dispatch(Push(ContactsPaths.Segments));
            }}
        />
    );
};

export const CustomFields = (): JSX.Element => {
    const dispatch = useDispatch();
    const location = useLocation();
    const query: any = parse(location.search);
    const [activePage, setActivePage] = useState(parseInt(query.page, 10) || 1);
    const [perPage, setPerPage] = useState(parseInt(query.perPage, 10) || DEFAULT_PER_PAGE_COUNT);
    const [search, setSearch] = useState(query.search || '');
    const { config } = useSelector((state: ApplicationState) => state);
    const Wrapper = config.isStandalone ? Container : ScreenContainer;
    const canModifyCustomFields = hasAccessLevel(AccessLevel.ModifyCustomFields);

    useEffect(() => {
        const offset = activePage * perPage - perPage;
        dispatch(GetContactFieldsStart({ limit: perPage, offset, search }));
    }, [activePage, perPage, search]);

    return (
        <Wrapper>
            <TopNavigation />
            {canModifyCustomFields && <AddNewField />}
            <CustomFieldsTable
                activePage={activePage}
                setActivePage={setActivePage}
                perPage={perPage}
                setPerPage={setPerPage}
                search={search}
                setSearch={setSearch}
            />
        </Wrapper>
    );
};
